var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabla',{attrs:{"headers":_vm.headers,"data":_vm.alianzas,"loading":_vm.fetchingData,"footer":true,"porcentajes":true,"switch-porcentajes":true,"switch-class":""}})}
var staticRenderFns = []

export { render, staticRenderFns }